
import { useState } from "react";
import { WalletIcon, BrainIcon, CalendarIcon, TrendingUpIcon } from "@/components/icons/LuxuryIcons";

const GlowAppSimple = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const appScreens = [
    {
      title: "Your Glow Wallet",
      description: "Track credits, rewards, and savings",
      icon: WalletIcon
    },
    {
      title: "Smart Quiz",
      description: "AI-powered treatment recommendations",
      icon: BrainIcon
    },
    {
      title: "Instant Booking",
      description: "Same-day appointments at your fingertips",
      icon: CalendarIcon
    },
    {
      title: "Progress Tracking",
      description: "Watch your glow journey unfold",
      icon: TrendingUpIcon
    }
  ];

  const ActiveIcon = appScreens[activeSlide].icon;

  return (
    <section className="py-32 bg-juv-soft-blush/30">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-juv-deep-chestnut mb-6">
            The Glow App
          </h2>
          <p className="text-lg md:text-xl text-juv-deep-chestnut/70 leading-relaxed max-w-3xl mx-auto">
            Your beauty journey, simplified. From discovery to booking to tracking results, 
            everything you need is in your pocket.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Phone Mockup */}
          <div className="relative">
            <div className="relative mx-auto w-80 h-[640px] bg-black rounded-[3rem] p-6 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2rem] overflow-hidden relative">
                {/* Phone Screen Content */}
                <div className="p-8 h-full flex flex-col justify-center items-center text-center bg-gradient-to-br from-juv-cream-white to-juv-soft-blush">
                  <div className="mb-6">
                    <ActiveIcon 
                      size={64} 
                      className="text-juv-terracotta mx-auto" 
                      strokeWidth={1}
                    />
                  </div>
                  <h3 className="text-2xl font-semibold text-juv-deep-chestnut mb-3">
                    {appScreens[activeSlide].title}
                  </h3>
                  <p className="text-juv-deep-chestnut/70">
                    {appScreens[activeSlide].description}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Feature List */}
          <div>
            {/* App Feature Pills */}
            <div className="space-y-4">
              {appScreens.map((screen, index) => {
                const ScreenIcon = screen.icon;
                return (
                  <button
                    key={index}
                    onClick={() => setActiveSlide(index)}
                    className={`w-full text-left p-6 rounded-2xl transition-all duration-300 ${
                      activeSlide === index
                        ? 'bg-white shadow-lg transform scale-105 border-2 border-juv-terracotta/20'
                        : 'bg-white/50 hover:bg-white/70 border-2 border-transparent'
                    }`}
                  >
                    <div className="flex items-center space-x-4">
                      <div className="flex-shrink-0">
                        <ScreenIcon 
                          size={32} 
                          className={`transition-colors duration-300 ${
                            activeSlide === index ? 'text-juv-terracotta' : 'text-juv-deep-chestnut/60'
                          }`}
                          strokeWidth={1.5}
                        />
                      </div>
                      <div>
                        <h4 className={`font-semibold mb-1 transition-colors duration-300 ${
                          activeSlide === index ? 'text-juv-deep-chestnut' : 'text-juv-deep-chestnut/80'
                        }`}>
                          {screen.title}
                        </h4>
                        <p className={`text-sm transition-colors duration-300 ${
                          activeSlide === index ? 'text-juv-deep-chestnut/70' : 'text-juv-deep-chestnut/50'
                        }`}>
                          {screen.description}
                        </p>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlowAppSimple;
